module.exports = __webpack_public_path__ + "img/risk-assessment_a.e78233f4.png";